import { APP_BASE_HREF } from '@angular/common';
import { makeEnvironmentProviders } from '@angular/core';
import { environment } from '@environment/environment';

export const provideBasePath = () =>
  makeEnvironmentProviders([
    {
      provide: APP_BASE_HREF,
      useValue: `${environment.appInfo.baseHref}/`
    }
  ]);
